import React, {Component} from 'react';
import PropTypes from 'prop-types';
import '../Widgets.scss';
import './MessagesWidget.scss';
import Dropdown from 'react-dropdown';
import iconSvg from '../../assets/img/svgLib/iconsSvg';
import {FormControl} from "react-bootstrap";
import Notice from '../../shared/Notice/Notice';

class MessagesWidget extends Component {
    static propTypes = {
        userInfo: PropTypes.object,
        classPrefix: PropTypes.string,
    }
    constructor(props) {
        super(props)

        this.pageSetting = {
            title: 'Сообщения'
        };

        this.state = {
            noticeStatuses: [
                {value: 'all', label: 'Все'},
                {value: 'read', label: 'Прочитанные'},
                {value: 'new', label: 'Актуальные'},
            ],
            activeCard: null,
            activeStatuses: 'all',
            showDropDown: true,
            searcherValue: '',
            noticeTemp: null,
        }

    }

    handleActiveCard = (index) => { //TODO Изменение статсуа Уведомления - бэк запрос на апдейт записи
        const {noticeTemp} = this.state;
        const elem = noticeTemp[index];
        elem.viewStatus = 'read';
        noticeTemp.splice(index, 1, elem);
        this.setState({
            activeCard: index,
        })
    }

    handleSearcher = e => {
        this.setState({
            searcherValue: e.target.value,
        })
    }

    handleDropDownStatuses = (e) => {
        this.setState({
            activeStatuses: e.value,
        })
    }

    toggleSearchMode = (event) => {
        this.setState({
            showDropDown: event
        })
    }

    get statusDropDown() {
        const {noticeStatuses, activeStatuses} = this.state;
        return (
            <div className={'dropDownStatuses'}>
                <Dropdown
                    options={noticeStatuses}
                    value={activeStatuses}
                    menuClassName={'dropDownMenu'}
                    arrowClassName={'arrowDropMenu'}
                    onChange={this.handleDropDownStatuses} />
            </div>
        )
    }

    get searcherBlock() {
        const {searcherValue, showDropDown} = this.state;
        return (
            <div className={'searcher'}>
                {showDropDown ? (
                    <div
                        className={'searcherTxt'}
                        onClick={() => this.toggleSearchMode(false)}>
                        <span className={'txt'}>Поиск</span>
                        <span>{iconSvg.search}</span>
                    </div>
                ) : (
                    <div className={'searcherInput'}>
                        <FormControl
                            type={'text'}
                            value={searcherValue}
                            placeholder={'Что будем искать?'}
                            onChange={this.handleSearcher}
                        />
                        <span className={'search'}>{iconSvg.search}</span>
                        <span
                            className={'close'}
                            onClick={() => this.toggleSearchMode(true)}>
                            {iconSvg.close}
                            </span>
                    </div>
                )
                }
            </div>
        )
    }

    get noticeList() {
        const {noticeTemp, activeCard, activeStatuses} = this.state;

        return (
            <div className={'noticeList'}>
                {noticeTemp ? noticeTemp.map((item, i) => {
                    return activeStatuses === 'all' ||
                    activeStatuses === item.viewStatus ?
                        (                    <div key={`notice_${i}`}>
                            <Notice idx={i}
                                    notice={item}
                                    active={activeCard === i}
                                    handle={this.handleActiveCard}/>
                        </div>) : null
                }) : <div className={'emptyList'}>Сообщений нет</div>}
            </div>
        )
    }

    render() {
        const {statusDropDown, searcherBlock, noticeList} = this;
        const {classPrefix} = this.props;
        const {showDropDown} = this.state;
        const {title} = this.pageSetting;

        return (<div className={`contentBody${classPrefix}`}>
            <div className={'widgetTitle'}>
                {title}
            </div>
            <div className={'notificationContent'}>
                <div className={'helpersBlock'}>
                    {showDropDown ? statusDropDown : null}
                    {searcherBlock}
                </div>
                {noticeList}
            </div>

        </div>)
    }
}

export default MessagesWidget




// WEBPACK FOOTER //
// ./src/Widget/MessagesWidget/MessagesWidget.js